import { BroadcastChannelAdapter } from "./BroadcastChannelAdapter";

/**
 * Sync singleton factory.
 * Phase 1: BroadcastChannel. Phase 2+: swap to WebSocketAdapter here.
 * Consumers import `sync` and only see the SyncAdapter contract.
 */

let instance = null;

export function getSync() {
  if (!instance) {
    instance = new BroadcastChannelAdapter("ic-bingo-sync");
  }
  return instance;
}

export const sync = getSync();

export * from "./events";
